import * as React from "react";
import { singleton } from "logic/singleton";
const TelemetryContext = React.createContext({
  sendTelemetry: () => {
  },
  sendErrorReport: () => {
  }
});
export default singleton("contexts.TelemetryContext", () => TelemetryContext);
